export function UpdateMessageTemplates(this: any) {
  return {
    templateId: this.templateId,
    IsDelete: this.isDelete,
  };
}
